module.exports = __webpack_public_path__ + "static/media/Abhishek2.41cdd32d.jpeg";